import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../api/api-response';
import { RegraPlano, SalvarRegraPlanoPayload } from './regra-plano.model';

@Injectable({ providedIn: 'root' })
export class RegraPlanoService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/Cupom`;

  listar(nrSeqCupom: number): Observable<ApiResponse<RegraPlano[]>> {
    return this.http.get<ApiResponse<RegraPlano[]>>(`${this.url}/${nrSeqCupom}/regra-plano`);
  }

  criar(nrSeqCupom: number, payload: SalvarRegraPlanoPayload): Observable<ApiResponse<number>> {
    return this.http.post<ApiResponse<number>>(`${this.url}/${nrSeqCupom}/regra-plano`, payload);
  }

  excluir(nrSequencia: number): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${this.url}/regra-plano/${nrSequencia}`);
  }
}
